import React from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModelTaskTableBodyRow from "./ModelTaskTableBodyRow";
import { ACTION_ROW_HEIGHT } from "./rowConstants";

const NextPageStatusRow = ({ nextPage, columnCount, classes }) => {
	const { t } = useTranslation();
	if (nextPage.isError) {
		return (
			<ModelTaskTableBodyRow
				columnCount={columnCount}
				height={ACTION_ROW_HEIGHT}
				className={classes.tableAction}
				onClick={nextPage.fetch}
			>
				{t("action.retryLoadingMoreTasks")}
			</ModelTaskTableBodyRow>
		);
	}
	if (nextPage.isFetching) {
		return (
			<ModelTaskTableBodyRow
				columnCount={columnCount}
				height={ACTION_ROW_HEIGHT}
				className={classes.tableActionBusy}
			>
				<CircularProgress size={20} aria-label="Loading more tasks" />
			</ModelTaskTableBodyRow>
		);
	}
	return null;
};

NextPageStatusRow.propTypes = {
	nextPage: PropTypes.shape({
		isError: PropTypes.bool.isRequired,
		isFetching: PropTypes.bool.isRequired,
		fetch: PropTypes.func.isRequired,
	}).isRequired,
	columnCount: PropTypes.number.isRequired,
	classes: PropTypes.object.isRequired,
};

export default NextPageStatusRow;
